import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '../../Themes';

import styles from './Divider.Styles';

function Divider({ theme, color, width, height, containerStyle, style }) {
  return (
    <View style={[styles.dividerContainer, containerStyle]}>
      <View style={[styles.divider(width, height, theme, color), style]} />
    </View>
  );
}

Divider.defaultProps = {
  theme: LightThemeColors,
};
Divider.propTypes = {
  theme: PropTypes.objectOf({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  containerStyle: ViewPropTypes.style,
  style: ViewPropTypes.style,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
};

export default withTheme(Divider);
